import { gradeLettersInsteadOfScore } from '../../../../utils/gradeLettersInsteadOfScore';

export const hoverCreator = ({ arc, rawData, tooltip }) => (e) => {
  const rect = e.target.getBoundingClientRect();
  const top = rect.top;
  const left = rect.left;

  if (left === tooltip.left && top === tooltip.top && tooltip.indicator === arc.index + 1) {
    return;
  }

  const score = gradeLettersInsteadOfScore(rawData[arc.index]);

  tooltip.show({
    data: { ...arc, score, indicator: `PI-${arc.index + 1}` },
    top,
    left,
  });
};
